import './style.scss';

export function careers_block() {
    const block = document.querySelector('.careers_block');
    if (!block) return;

}
